import {
  GET_EVENT_PLANNING_REQUEST,
  SET_EVENT_PLANNING,
  EVENT_PLANNING_LOADING,
} from "./Types";

const INITIAL_STATE = {
  eventPlanningList: [],
  eventPlanning: {},
  count: 0,
  load: {
    loading: false,
    type: "",
  },
};

export const eventPlanningReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case EVENT_PLANNING_LOADING:
      return {
        ...state,
        load: {
          loading: action.payload.loading,
          type: action.payload.type,
        },
      };
    case GET_EVENT_PLANNING_REQUEST:
      return {
        ...state,
        load: {
          loading: false,
          type: "",
        },
        eventPlanningList:
          action.payload.data?.event_requests || action.payload.data || [],
        count:
          action.payload.extra?.total_count || action.payload.meta?.total || 0,
      };

    case SET_EVENT_PLANNING:
      return {
        ...state,
        load: {
          loading: false,
          type: "",
        },
        eventPlanning:
          action.payload.data?.event_planning || action.payload.data || {},
      };

    default:
      return state;
  }
};
